import IconArrowRight from '@apollo/icons/default/IconArrowRight.svg';
import IconExpandList from '@apollo/icons/default/IconExpandList.svg';
import { IconButton } from '@apollo/orbit';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

import { SortOrder } from './shared';

export const FieldSortingButton = ({
  sortOrder,
  setSortOrder,
}: {
  sortOrder: SortOrder;
  setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;
}) => (
  <Tooltip
    placement="top"
    label={
      sortOrder === 'none'
        ? 'Sort Alphabetically Ascending'
        : sortOrder === 'alphabeticalAscending'
          ? 'Sort Alphabetically Descending'
          : 'Remove Field Sort'
    }
  >
    <IconButton
      variant="hidden"
      size="sm"
      onClick={() =>
        setSortOrder(
          sortOrder === 'none'
            ? 'alphabeticalAscending'
            : sortOrder === 'alphabeticalAscending'
              ? 'alphabeticalDescending'
              : 'none',
        )
      }
      aria-label={`Set sort order to ${
        sortOrder === 'none'
          ? 'alphabetical ascending'
          : sortOrder === 'alphabeticalAscending'
            ? 'alphabetical descending'
            : 'sdl ordering'
      }`}
      icon={
        sortOrder === 'none' ? (
          <IconExpandList />
        ) : sortOrder === 'alphabeticalAscending' ? (
          <IconArrowRight className="rotate-90" />
        ) : (
          <IconArrowRight className="-rotate-90" />
        )
      }
    />
  </Tooltip>
);
